import { render, staticRenderFns } from "./SpecialisationAdd.vue?vue&type=template&id=18014842&lang=pug&"
import script from "./SpecialisationAdd.vue?vue&type=script&lang=js&"
export * from "./SpecialisationAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports